import React from 'react';

const About = () => {
     return (
          <div className='flex justify-center items-center'>
               <h1 className='text-8xl mr-6 text-green-500 font-mono'>About Us</h1>
               <img className='mt-10 rounded-lg' src="https://media.istockphoto.com/vectors/solutions-vector-id854342964?k=20&m=854342964&s=612x612&w=0&h=yqWhpjZO6QWZxGboI6ZnZbM1O0OcdA_7HcJId_OK3Aw=" alt="" />
          </div>
     );
};

export default About;